<template>
  <v-card class="pa-6" flat>
    <v-row class="mt-2">
      <v-btn
        icon
        class="hidden-xs-only ml-3"
        color="primary"
        @click="$router.push('/dashboard')"
      >
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <p class="text-h5 bold ml-4">USUÁRIOS</p>
      <v-spacer />
      <v-btn class="bold" color="secondary" x-large rounded @click="createUser">
        <v-icon>mdi-plus</v-icon>
        <span class="login pa-2">NOVO USUÁRIO</span>
      </v-btn>
    </v-row>

    <v-form ref="form" v-model="valid" lazy-validation>
      <v-card-title>
        <v-row :gutters="25">
          <v-col cols="12" sm="12" md="3" lg="3" xl="3" class="pl-0 pb-0">
            <v-text-field
              v-model="form.name"
              label="Nome"
              single-line
              hide-details
              outlined
              large
            />
          </v-col>
          <v-col cols="12" sm="12" md="3" lg="3" xl="3" class="pl-0 pb-0">
            <v-select
              v-model="form.profileId"
              :items="profilesOptions"
              label="Perfil do Usuário"
              outlined
            />
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="3"
            lg="3"
            xl="3"
            class="
              pl-0
              d-flex
              justify-center
              justify-sm-center
              justify-md-start
              justify-lg-start
              justify-xl-start
            "
          >
            <v-btn class="bold" color="secondary" x-large @click="getUsers">
              <span class="login pa-2">Consultar</span>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
    </v-form>
    <v-data-table :headers="headers" :items="users">
      <template v-slot:[`item.isActive`]="{ item }">
        <v-chip :color="getColor(item.isActive)" dark>
          {{ item.isActive ? 'Sim' : 'Não' }}
        </v-chip>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="getPermissionsEdit(item.profile.id)"
              icon
              large
              v-bind="attrs"
              v-on="on"
              @click="openEdit(item)"
            >
              <v-icon> mdi-pencil-outline </v-icon>
            </v-btn>
          </template>
          <span>Editar usuário</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="
                user &&
                user.profileId === profiles.ADMINISTRADOR &&
                user.id !== item.id
              "
              icon
              large
              v-bind="attrs"
              v-on="on"
              @click="generateNewPassword(item)"
            >
              <v-icon> mdi-lock-outline </v-icon>
            </v-btn>
          </template>
          <span>Enviar nova senha</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="user && user.profileId === profiles.ADMINISTRADOR"
              icon
              large
              v-bind="attrs"
              v-on="on"
              @click="deleteUser(item)"
            >
              <v-icon> mdi-delete-outline </v-icon>
            </v-btn>
          </template>
          <span>Excluir usuário</span>
        </v-tooltip>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { profilesOptions, profiles } from '../utils/Profiles';

// eslint-disable-next-line import/no-cycle
import {
  getUsers,
  deleteUserById,
  generateNewPasswordUser,
} from '@/services/user';

export default {
  name: 'Users',
  data: () => ({
    profilesOptions,
    profiles,
    valid: false,
    form: {
      name: '',
      profileId: '',
    },
    headers: [
      {
        text: 'Nome',
        align: 'start',
        filterable: true,
        value: 'firstName',
        class: 'primary',
      },
      {
        text: 'Sobrenome',
        align: 'start',
        filterable: true,
        value: 'lastName',
        class: 'primary',
      },
      {
        text: 'Data de Entrada no PEJA',
        align: 'start',
        filterable: true,
        value: 'dob',
        class: 'primary',
      },
      {
        text: 'E-mail',
        align: 'start',
        filterable: true,
        value: 'email',
        class: 'primary',
      },
      {
        text: 'Ativo',
        align: 'start',
        filterable: true,
        value: 'isActive',
        class: 'primary',
      },
      {
        text: 'Perfil',
        align: 'start',
        filterable: true,
        value: 'profile.description',
        class: 'primary',
      },
      {
        text: 'Ações',
        value: 'actions',
        sortable: false,
        class: 'primary',
        align: 'start',
      },
    ],
    users: [],
  }),
  computed: {
    ...mapGetters({ user: 'user/getUser' }),
  },
  mounted() {
    this.getUsers();
  },
  methods: {
    ...mapActions('loading', ['showLoading', 'hideLoading']),
    async getUsers() {
      try {
        this.showLoading();
        const { data } = await getUsers(this.form);

        this.users =
          data.rows && data.rows.length > 0
            ? data.rows.filter((el) => el.id !== this.user.id)
            : [];
      } catch (e) {
        if (this.$root.vtoast) {
          this.$root.vtoast.show({
            message: 'Erro ao buscar usuários.',
            top: true,
            right: true,
            show: true,
            color: 'error',
          });
        }
      } finally {
        this.hideLoading();
      }
    },
    getColor(value) {
      if (value) return 'green';
      return 'red';
    },
    createUser() {
      this.$router.push({ name: 'FormUser', params: { edit: false } });
    },
    openEdit(item) {
      this.$router.push({
        name: 'FormUser',
        params: { edit: true, userToEdit: item },
      });
    },
    async deleteUser({ id }) {
      await deleteUserById({ id });
      this.getUsers();
    },
    getPermissionsEdit(profileId) {
      let valid = false;
      switch (this.user.profile.id) {
        case profiles.COORDENADOR_DOCENTE:
        case profiles.COORDENADOR_DISCENTE:
          valid = this.user.profile.id > profileId;
          break;
        case profiles.MONITOR_VOLUNTARIO:
          valid =
            profileId === profiles.EDUCANDO ||
            profileId === profiles.USUARIO_EXTERNO;
          break;
        case profiles.MONITOR_BOLSISTA:
          valid =
            profileId === profiles.EDUCANDO ||
            profileId === profiles.USUARIO_EXTERNO ||
            profileId === profiles.MONITOR_VOLUNTARIO;
          break;
        default:
          valid = true;
          break;
      }
      return valid;
    },
    async generateNewPassword(item) {
      try {
        this.showLoading();
        const resultado = await generateNewPasswordUser({
          userId: item.id,
        });

        if (resultado && !resultado.success) {
          this.$root.vtoast.show({
            message: 'Erro ao enviar a nova senha.',
            top: true,
            right: true,
            show: true,
            color: 'error',
          });
        } else {
          this.$root.vtoast.show({
            message: `Nova senha enviada com sucesso.`,
            top: true,
            right: true,
            show: true,
            color: 'success',
          });
        }
      } catch (e) {
        this.$root.vtoast.show({
          message: 'Erro ao enviar a nova senha.',
          top: true,
          right: true,
          show: true,
          color: 'error',
        });
      } finally {
        this.hideLoading();
      }
    },
  },
};
</script>

<style scoped>
.bold {
  font-weight: bold;
}

*
  >>> .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr:last-child
  > th {
  color: white;
}

*
  >>> .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr:last-child
  > th:hover {
  color: white;
}

* >>> .mdi-arrow-up::before {
  color: white;
}
</style>
